import React from 'react';

import Card from '~/components/ui/Card';

const PlaybillContent = props => {
  const cards = props.data.map(c => {
    return <Card key={c.id} {...c} />;
  });

  const countedCards =
    props.count <= cards.length ? cards.slice(0, props.count) : cards;

  const btnMore =
    countedCards < cards ? (
      <button
        className="btn btn--outline btn--loadmore"
        onClick={() => props.increaseCount()}
      >
        Загрузить еще
      </button>
    ) : null;

  const emptyResult = (
    <p className="txt txt--center empty-txt">
      Мы не нашли программ по таким фильтрам. Посмотрите{' '}
      <a className="link" onClick={e => document.location.reload()}>
        ближайшие мероприятия
      </a>
      .
    </p>
  );

  return (
    <section className="section section--schedule section--pb-lg">
      <div className="container">
        <div className="cards cards--line cards--line_orange cards--inner cards--border">
          <ul className="cards__items">
            {countedCards.length ? countedCards : emptyResult}
            {btnMore}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default PlaybillContent;
